// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"4d77501d","969":"91b242b7"}[chunkId] + ".chunk.js";
};